import React, { useState } from "react";
import { createGame, joinGame } from "./api";
import "./LobbyScreen.css";

function LobbyScreen({ onJoined }) {
  const [gameIdInput, setGameIdInput] = useState("");
  const [playerName, setPlayerName] = useState("");
  const [customWords, setCustomWords] = useState(Array(12).fill(""));
  const [error, setError] = useState(null);

  async function handleJoinExisting(e) {
    e.preventDefault();
    setError(null);
    try {
      const data = await joinGame(gameIdInput.trim(), playerName.trim() || "Anonym");
      onJoined({
        gameId: data.gameId,
        playerId: data.playerId,
        playerName: playerName.trim() || "Anonym",
        words: data.words
      });
    } catch (err) {
      setError("Hra nenalezena nebo chyba při připojení.");
    }
  }

  async function handleCreateGame(e) {
    e.preventDefault();
    setError(null);

    const trimmed = customWords.map((w) => w.trim());
    const nonEmpty = trimmed.filter((w) => w);

    if (nonEmpty.length === 0) {
      setError("Zadej prosím alespoň jedno slovo pro bingo.");
      return;
    }

    try {
      // Pošleme všech 12 polí, backend prázdná zahodí
      const data = await createGame(trimmed);
      const joinData = await joinGame(data.gameId, playerName.trim() || "Anonym");
      onJoined({
        gameId: joinData.gameId,
        playerId: joinData.playerId,
        playerName: playerName.trim() || "Anonym",
        words: joinData.words
      });
    } catch (err) {
      setError("Chyba při vytvoření hry.");
    }
  }

  function updateWord(i, value) {
    const next = [...customWords];
    next[i] = value;
    setCustomWords(next);
  }

  return (
    <div className="lobby-root">
      <div className="lobby-card">
        <h1>Moje Bingo</h1>

        <div className="lobby-section">
          <label className="lobby-label">
            Tvoje přezdívka:
            <input
              value={playerName}
              onChange={(e) => setPlayerName(e.target.value)}
              className="lobby-input"
              placeholder="Např. Honza"
            />
          </label>
        </div>

        <div className="lobby-split">
          {/* Připojení do existující hry */}
          <div className="lobby-column">
            <h2>Připojit se k existující hře</h2>
            <form onSubmit={handleJoinExisting}>
              <label className="lobby-label">
                Číslo hry:
                <input
                  value={gameIdInput}
                  onChange={(e) => setGameIdInput(e.target.value)}
                  className="lobby-input"
                  placeholder="např. 823457"
                />
              </label>
              <button type="submit" className="lobby-button">
                Připojit se
              </button>
            </form>
          </div>

          {/* Vytvoření nové hry */}
          <div className="lobby-column">
            <h2>Vytvořit vlastní hru</h2>
            <form onSubmit={handleCreateGame}>
              <p className="lobby-hint">
                Můžeš vyplnit až 12 slov. Prázdná políčka se v bingu nebudou hrát.
              </p>
              <div className="lobby-words-grid">
                {customWords.map((w, i) => (
                  <input
                    key={i}
                    value={w}
                    onChange={(e) => updateWord(i, e.target.value)}
                    placeholder={`Slovo ${i + 1}`}
                    className="lobby-word-input"
                  />
                ))}
              </div>
              <button type="submit" className="lobby-button lobby-button--primary">
                Vytvořit hru
              </button>
            </form>
          </div>
        </div>

        {error && <div className="lobby-error">{error}</div>}
      </div>
    </div>
  );
}

export default LobbyScreen;
